// Environment URL utilities for HTTP and WebSocket endpoints
// Derives base URLs from current window location per provided rules

// Compute the HTTP base (no trailing slash) for current environment
export function getHttpBase() {
  const tempUrl = (typeof window !== "undefined" ? window.location.href : "").toLowerCase();

  let base = "https://dev1.askzoi.com";
  // base = "https://nimf1.askzoi.com/";

  if (tempUrl.indexOf("localhost") > -1) {
    base = "https://dev1.askzoi.com";
  } else if (tempUrl.indexOf("dev.askzoi.com") > -1) {
    base = "https://dev1.askzoi.com";
  } else if (tempUrl.indexOf("sia.technochimes.com") > -1) {
    base = "https://staging1.askzoi.com";
  } else if (tempUrl.indexOf("sia.salespanda.com") > -1) {
    base = "https://siaadmin.salespanda.com";
  } else if (tempUrl.indexOf("smartmfdpro.askzoi.com") > -1) {
    base = "https://smartmfdpro1.askzoi.com/";
  } else if (tempUrl.indexOf("nimf.askzoi.com") > -1) {
    base = "https://nimf1.askzoi.com/";
  } else if (tempUrl.indexOf("sia.nimfpartners.com") > -1) {
    base = "https://sia1.nimfpartners.com/";
  } else {
    base = "https://dev1.askzoi.com";
  }

  // Normalize to no trailing slash
  if (base.endsWith('/')) {
    base = base.slice(0, -1);
  }

  return base;
}

export function getWsBase() {
  const httpBase = getHttpBase();
  return httpBase.replace(/^http/i, "ws");
}

// Specific endpoint helpers used in the app
export function speechToTextUrl() {
  return `${getHttpBase()}/speech-to-text/`;
}

export function wsSpeech(sessionId) {
  return `${getWsBase()}/ws/speech/${sessionId}/`;
}

export function wsChatStream(sessionId) {
  return `${getWsBase()}/socket_stream/${sessionId}/`;
}

export function wsAudioBase64(sessionId) {
  return `${getWsBase()}/ws/audio_base64/${sessionId}/`;
}


